export enum DrivingExemptionView {
    GNHForm,
    LVCommuteForm
}

export enum GNHView {
    MyForm,
    Overview
}